// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"48a154f9","270":"d87ed4c7","362":"637b1aa1","394":"7db4019a","748":"d0b2ccb1","885":"3943a7b8"}[chunkId] + ".chunk.css";
};